export const getModuleIcon = (type) => {
    switch (type) {
      case 'Quiz':
        return '/images/quiz_icon.png';
      case 'carousal':
        return '/images/carousel.jpg'
      case 'content':
        return '/images/document_icon.png'
      case 'document':
        return '/images/copyright_icon.png';
      default:
        return '/images/copyright_icon.png';
    }
  };
  